<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div>
    <div class="left-side-menu mm-active" :class="{ 'test-environment-style': isNotProduction }">
      <!-- LOGO -->
      <slot name="logo" />

      <!--- Sidemenu -->
      <slot name="sales" />
      <!-- End Sidebar -->

      <!--- Sidemenu -->
      <slot name="items" />
      <!-- End Sidebar -->

      <div class="clearfix" />
      <!-- Sidebar -left -->
    </div>
  </div>
  <!-- Left Sidebar End -->
</template>

<script setup>
import { computed } from 'vue'

const isNotProduction = computed(() => import.meta.env.MODE !== 'production')
</script>

<style scoped>
@media (max-width: 1025px) {
  .test-environment-style {
    padding-top: 20px;
  }
}
</style>
